@if (label()) {
    <form-label
        [id]="id() + '-label'"
        [forId]="id() + '-datepicker'"
        [label]="label()"
        [required]="required()"
        [tooltipText]="tooltipText()"
        [hasError]="invalid()">
    </form-label>
}

<p-datePicker
    [inputId]="id() + '-datepicker'"
    [(ngModel)]="value"
    [view]="view()"
    [dateFormat]="dateFormat()"
    [selectionMode]="selectionMode()"
    [readonlyInput]="readonlyInput()"
    [showClear]="showClear()"
    [showButtonBar]="showButtonBar()"
    [showIcon]="true"
    [placeholder]="placeholder() | translate"
    [appendTo]="'body'"
    [invalid]="invalid()"
    [fluid]="true"
    [size]="size()"
    [iconDisplay]="'input'"
    [maxDate]="maxDateTodayUTC() ? endOfCurrentDayUTC : maxDate()"
    [minDate]="minDateTodayUTC() ? startOfCurrentDayUTC : minDate()"
    [disabled]="disabled()"
    (onClear)="onClear()"
    (onClearClick)="onClear()"
    (onShow)="onOpen()"
    (onClose)="onClose()"></p-datePicker>
